import Image from 'next/image'

export function Logo() {
  return (
    <div className="relative max-w-[7rem]">
      <Image
        src="/images/logoWithText.png"
        alt="NextAdmin logo"
        role="presentation"
        width={174}
        height={40}
        sizes="174px"
      />
    </div>
  )
}
